import React from "react";

export default React.memo(
  ({
    token,
    refreshtoken,
    children,
    text,
    image,
    appSelectorAlternativeUrl,
    language,
    ...rest
  }) => {
    const separator = "||||||";
    const path = "auth/bytoken/";
    const href =
      appSelectorAlternativeUrl +
      (token && refreshtoken ? path + token + separator + refreshtoken : "") + '?language=' + language;

    return (
      <a {...rest} href={href}>
        {children}
        {text ? " massphoning-in" : <img alt="Massphoning" src={image} />}
      </a>
    );
  }
);
